// extracted by mini-css-extract-plugin
module.exports = {"rated":"rated_rated__D91Cf","rate":"rated_rate__edxjS","ratedText":"rated_ratedText__YGRT9","badgeImage":"rated_badgeImage__dglui","bordered":"rated_bordered__IJKNv"};